// @flow
/**
 * User: Mike Chung
 * Date: 20/1/2018
 * Time: 5:10 PM
 */

import type {SsoUserActionCollection} from "../actions/sso/ssoUserAction";

export type SsoUserActionState = {

    sendForgotPassword: {
        [ssoUid: string]: {
            isLoading: boolean,
            error?: any
        }
    },
    resendActivation: {
        [ssoUid: string]: {
            isLoading: boolean,
            error?: any
        }
    },
    activateUser: {
        [ssoUid: string]: {
            isLoading: boolean,
            error?: any
        }
    }
}

const INITIAL_STATE: SsoUserActionState = {
    sendForgotPassword: {},
    resendActivation: {},
    activateUser: {}
};

export default function reducer(state: SsoUserActionState = INITIAL_STATE, action: SsoUserActionCollection) {

    let result = {
        ...state
    };

    switch (action.type) {
        case "sso/SEND_FP_EMAIL_START_ACTION":
            result.sendForgotPassword[action.ssoUid] = {
                isLoading: true
            };
            return Object.assign({}, result);
        case "sso/SEND_FP_EMAIL_SUCCESS_ACTION":
            result.sendForgotPassword[action.ssoUid] = {
                isLoading: false
            };
            return Object.assign({}, result);
        case "sso/SEND_FP_EMAIL_FAILED_ACTION":
            result.sendForgotPassword[action.ssoUid] = {
                isLoading: false,
                error: Object.assign({}, action.error)
            };
            return Object.assign({}, result);
        case "sso/RESEND_EMAIL_START_ACTION":
            result.resendActivation[action.ssoUid] = {
                isLoading: true
            };
            return Object.assign({}, result);
        case "sso/RESEND_EMAIL_SUCCESS_ACTION":
            result.resendActivation[action.ssoUid] = {
                isLoading: false
            };
            return Object.assign({}, result);
        case "sso/RESEND_EMAIL_FAILED_ACTION":
            result.resendActivation[action.ssoUid] = {
                isLoading: false,
                error: Object.assign({}, action.error)
            };
            return Object.assign({}, result);
        case "sso/ACTIVATE_USER_START_ACTION":
            result.activateUser[action.ssoUid] = {
                isLoading: true
            };
            return Object.assign({}, result);
        case "sso/ACTIVATE_USER_SUCCESS_ACTION":
            result.activateUser[action.ssoUid] = {
                isLoading: false
            };
            return Object.assign({}, result);
        case "sso/ACTIVATE_USER_FAILED_ACTION":
            result.activateUser[action.ssoUid] = {
                isLoading: false,
                error: Object.assign({}, action.error)
            };
            return Object.assign({}, result);
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/SsoUserActionReducer.js